import { render } from "./AllTicketsClaimWaiting.vue?vue&type=template&id=25560c50&scoped=true&ts=true"
import script from "./AllTicketsClaimWaiting.vue?vue&type=script&lang=ts"
export * from "./AllTicketsClaimWaiting.vue?vue&type=script&lang=ts"

import "./AllTicketsClaimWaiting.vue?vue&type=style&index=0&id=25560c50&scoped=true&lang=less"
import "./AllTicketsClaimWaiting.vue?vue&type=style&index=1&id=25560c50&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25560c50"]])

export default __exports__